var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.36686,
    cy: 8.21238,
    r: 7.89304,
    fill: "#F53838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36677 0.319336C4.00749 0.319336 0.473694 3.85313 0.473694 8.21241C0.473694 12.5717 4.00749 16.1055 8.36677 16.1055C12.726 16.1055 16.2598 12.5717 16.2598 8.21241C16.2598 3.85313 12.726 0.319336 8.36677 0.319336ZM10.2364 5.77378H9.05001C8.90942 5.77378 8.7532 5.95877 8.7532 6.20461V7.06134H10.2373L10.0128 8.28312H8.7532V11.9509H7.353V8.28312H6.08271V7.06134H7.353V6.34274C7.353 5.3117 8.06831 4.47389 9.05001 4.47389H10.2364V5.77378Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.31f5bdfc997602bb19339a8b1256f0de.svg";
export { ForwardRef as ReactComponent };